export interface AeroUseResultPublicationCandidate {
    promotedExitCandidateId: number | null;
    variantHash: string;
}

export interface AeroUseResultPublicationState {
    globalCandidateIds: number[];
    isEverySelectionPublished: boolean;
    needsPromotion: boolean;
    unpublishedVariantHashes: string[];
}

export const buildAeroUseResultPublicationState = (candidates: AeroUseResultPublicationCandidate[]): AeroUseResultPublicationState => {
    const globalCandidateIds = Array.from(
        new Set(
            candidates
                .map((candidate) => candidate.promotedExitCandidateId)
                .filter((candidateId): candidateId is number => candidateId !== null)
        )
    );
    const unpublishedVariantHashes = Array.from(
        new Set(candidates.filter((candidate) => candidate.promotedExitCandidateId === null).map((candidate) => candidate.variantHash))
    );
    const needsPromotion = unpublishedVariantHashes.length > 0;

    return {
        globalCandidateIds,
        isEverySelectionPublished: candidates.length > 0 && !needsPromotion,
        needsPromotion,
        unpublishedVariantHashes
    };
};

export const canAttachAeroUseResult = ({
    backendReady,
    isBusy,
    isOverSelectionLimit,
    needsPromotion,
    selectedCount,
    targetStrategyId
}: {
    backendReady: boolean;
    isBusy: boolean;
    isOverSelectionLimit: boolean;
    needsPromotion: boolean;
    selectedCount: number;
    targetStrategyId: number | null;
}) => (!needsPromotion || backendReady) && targetStrategyId !== null && selectedCount > 0 && !isOverSelectionLimit && !isBusy;
